<template>
    <el-container style="background: #f5f5f5;height: 100%;overflow: auto" class="website">
        <el-header style="height: 120px;text-align: center">
            <el-image :src="header" style="height: 120px"></el-image>
        </el-header>
        <el-main>
            <el-form label-width="100px" :model="inteboWebSite" :rules="rules" ref="form">
                <el-form-item label="姓名" prop="custname">
                    <el-input v-model="inteboWebSite.custname"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="inteboWebSite.phone" @change="phoneChange"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="smsCode">
                    <el-input v-model="inteboWebSite.smsCode" @change="smsCodeChange">
                        <el-button slot="append" type="primary" @click="sendSms">{{lebel}}</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="品牌名称">
                    <el-input v-model="inteboWebSite.storename"></el-input>
                </el-form-item>
                <el-form-item label="品牌所在地">
                    <van-cell :title="inteboWebSite.address" style="border: 1px solid #DCDFE6;" is-link  @click="showArea=true"/>
                </el-form-item>
                <el-form-item label="品牌类型">
                    <van-cell :title="inteboWebSite.storetype" style="border: 1px solid #DCDFE6;" is-link  @click="showStoreType=true"/>
                </el-form-item>
                <el-button type="primary" :loading="loading" style="width: 100%" @click="addInteboWebSite">提交</el-button>
            </el-form>
        </el-main>
        <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                @confirm="onConfirm"
                @cancel="showArea = false"
            />
        </van-popup>
        <van-popup v-model="showStoreType" position="bottom">
            <van-picker show-toolbar @confirm="onTypeConfirm" @cancel="showStoreType = false" :columns="columns" />
        </van-popup>
    </el-container>
</template>
<script>
import { areaList } from '@vant/area-data';
export default {
    data() {
        return {
            loading:false,
            rules: {
                custname: [
                    {required: true, message: "请输入姓名", trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: "请输入手机号码", trigger: 'blur'},
                ],
                smsCode: [
                    {required: true, message: "请输入验证码", trigger: 'blur'},
                ]
            },
            smsTime:0,
            lebel:"发送验证码",
            showStoreType:false,
            columns:[
                {text:"个人"},
                {text:"全国连锁"},
                {text:"区域连锁"},
                {text:"其他"},
            ],
            showArea:false,
            areaList:areaList,
            smsCode:"",
            inteboWebSite:{
                custname:"",
                phone:"",
                storename:"",
                address:"",
                remarks:"",
                storetype:"",
                createdate:"",
                smsCode:"",
            },
            timer:{},
            header:require('../../../assets/header.png')
        }
    },
    created() {
        this.getToken();
    },
    methods:{
        getToken(){
            this.$post("wechat/getToken").then(res=>{
                if(res.sucess){
                    localStorage.setItem("token",res.object);
                }
            });
        },
        addInteboWebSite(){
            this.loading=true;
            this.$refs["form"].validate((valid) => {
                if(valid){
                    this.$postw("inteboStore/addInteboWebSite",this.inteboWebSite).then(res=>{
                        this.loading=false;
                        if(res.sucess){
                            this.$message({message: "提交成功", type: 'success'});
                            this.inteboWebSite.custname="";
                            this.inteboWebSite.phone="";
                            this.inteboWebSite.storename="";
                            this.inteboWebSite.address="";
                            this.inteboWebSite.remarks="";
                            this.inteboWebSite.storetype="";
                            this.inteboWebSite.createdate="";
                            this.inteboWebSite.smsCode="";
                        }
                    });
                }
                else{
                    this.loading=false;
                }
            });
        },
        smsCodeChange(){
            if(!this.inteboWebSite.smsCode){
                this.$message({message: "请输入验证码", type: 'error'});
                return;
            }
            this.$post("sms/verificationCode",{phone:this.inteboWebSite.phone,code:this.inteboWebSite.smsCode}).then(res=>{
                if(res.sucess){

                }
                else{
                    this.inteboWebSite.smsCode="";
                }
            });
        },
        sendInteboVerCode(){
            this.$post("inteboStore/sendInteboVerCode",{phone:this.inteboWebSite.phone}).then(res=>{
                if(res.sucess){
                    this.$message({message: "验证码发送成功", type: 'success'});
                    clearInterval(this.timer);
                    this.smsTime = 60;
                    this.timer = setInterval(() => {
                        this.smsTime--;
                        this.lebel = this.smsTime + "s";
                        if (this.smsTime <= 0) {
                            clearInterval(this.timer);
                            this.lebel = "发送验证码";
                        }
                    }, 1000);
                }
            });
        },
        sendSms(){
            if(!this.inteboWebSite.phone){
                this.$message({message: "请输入手机号码", type: 'error'});
                return;
            }
            if (this.smsTime > 0) {
                return;
            }
            this.sendInteboVerCode();
        },
        phoneChange(){
            if(this.$checkMobile(this.inteboWebSite.phone)==false){
                this.$message({message: "手机号码不正确", type: 'error'});
                this.inteboWebSite.phone="";
                return;
            }
        },
        onTypeConfirm(value, index){
            this.inteboWebSite.storetype=value.text;
            this.showStoreType=false;
        },
        onConfirm(values){
            this.inteboWebSite.address = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.showArea = false;
        },
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
    .website .el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner{
        border-color:#409EFF;
        background-color:#409EFF;
        color: #FFF;
    }
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebowebsite/intebowebsite.vue